module.exports = __webpack_public_path__ + "img/icon-setup.f179dde4.svg";